import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryLink as PrimaryLinkBase } from "components/misc/Links.js";
import { ReactComponent as ArrowRightIcon } from "images/arrow-right-icon.svg";
import { ReactComponent as SvgDecoratorBlob1 } from "../../images/svg-decorator-blob-1.svg";
import { ReactComponent as SvgDecoratorBlob2 } from "../../images/svg-decorator-blob-2.svg";
import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";
import { ReactComponent as SvgDecoratorBlob4 } from "../../images/svg-decorator-blob-4.svg";
import { ReactComponent as SvgDecoratorBlob5 } from "../../images/svg-decorator-blob-5.svg";
import { ReactComponent as SvgDecoratorBlob6 } from "../../images/svg-decorator-blob-6.svg";
import { ReactComponent as SvgDecoratorBlob7 } from "../../images/svg-decorator-blob-7.svg";
import { ReactComponent as SvgDecoratorBlob8 } from "../../images/svg-decorator-blob-8.svg";
import { ReactComponent as SvgDecoratorBlob9 } from "../../images/svg-decorator-blob-9.svg";
import { ReactComponent as SvgDecoratorBlob10 } from "../../images/svg-decorator-blob-10.svg";


const API_URL = process.env.REACT_APP_IS_PROD == "true" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV


const DecoratorBlob1 = tw(
  SvgDecoratorBlob1
)`absolute w-32 top-0 left-0 ml-4 z-10 text-[#0049AC] opacity-25 transform -translate-x-full`;

const DecoratorBlob2 = tw(
  SvgDecoratorBlob2
)`absolute w-32 mt-4 right-0 z-10 text-[#0049AC] opacity-25 transform -translate-x-full`;

const DecoratorBlob3 = tw(
  SvgDecoratorBlob6
)`absolute w-32 top-0 right-0 z-10 text-[#0049AC] opacity-25 transform -translate-x-full`;

const DecoratorBlob4 = tw(
  SvgDecoratorBlob7
)`absolute w-32 top-0 left-0 ml-32 z-10 text-[#0049AC] opacity-25 transform -translate-x-full`;

const Container = tw.div`relative flex justify-center items-center bg-white`; // Changed background to white
const Content = tw.div`max-w-screen-xl mx-auto py-2 lg:py-4 flex flex-col items-center`;

const Column = tw.div``;
const HeadingColumn = tw(Column)`w-full`;

const HeadingInfoContainer = tw.div`text-center w-full px-0`;
const HeadingTitle = tw(SectionHeading)`text-center leading-tight`;
const HeadingDescription = tw.p`w-full max-w-screen-lg mx-auto text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100 mt-3 mb-4`; // Adjusted margins
const PrimaryLink = styled(PrimaryLinkBase)`
  ${tw`inline-flex justify-center items-center mt-6 text-lg`}
  svg {
    ${tw`ml-2 w-5 h-5`}
  }
`;

export default () => {
  const [content, setContent] = useState("Welcome to Traviator Holidays, your ultimate travel companion for unforgettable vacation experiences. Whether you're seeking a serene beach getaway, an adventurous mountain escape, or an exploration of vibrant cities, we offer a wide range of destinations tailored to your travel desires. With a passion for creating memorable journeys, Traviator Holidays ensures that every trip is filled with comfort, excitement, and extraordinary experiences. Let us help you plan the perfect holiday that suits your preferences, offering you unparalleled convenience and adventure at every step of the way.");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAboutText = async () => {
      try {

        const response = await fetch(`${API_URL}/web/home/aboutus?title=homeAboutUs`, {
          headers: {
            'X-API-Key': process.env.REACT_APP_ACCESS_API_KEY // Add API key to headers
          }
        });
        const result = await response.json();

        if (result.header.resCode === 200 && result.data.length > 0) {
          const textData = result.data.find((item) => item.title === "homeAboutUs");
          if (textData) {
            setContent(textData.content); // Set the video URL
          }
          setLoading(false);
        }
      } catch (error) {
        console.error('Error fetching text data:', error);
        setLoading(false);
      }
    };

    fetchAboutText();
  }, []);

  return (
    <Container>
      <Content>
        <DecoratorBlob2 />
        <HeadingColumn>
          <HeadingInfoContainer>
            <br /><br />
            <HeadingTitle>Your Travel Partner</HeadingTitle>
            <br />
            <HeadingDescription>
              {loading ? "Loading..." : content}
            </HeadingDescription>
            <DecoratorBlob1 />
            <DecoratorBlob4 />
            <PrimaryLink as={Link} to="/pg/know-us">
              Know More About Us <ArrowRightIcon />
            </PrimaryLink>
          </HeadingInfoContainer>
        </HeadingColumn>
        <DecoratorBlob3 />
      </Content>
    </Container>
  );
};
